import { Component, Input, OnInit } from '@angular/core';
import { JanelaApuracaoTaxaMediaMaximaAgente } from 'src/app/model/janela-apuracao-taxa-media-maxima-agente';
import { Tranche } from 'src/app/model/tranche.model';

@Component({
    selector: 'app-janelas-apuracao-listagem',
    templateUrl: './janelas-apuracao-listagem.component.html',
    styleUrls: ['./janelas-apuracao-listagem.component.scss'],
    standalone: false
})
export class JanelasApuracaoListagemComponent implements OnInit {

  @Input() janelas: JanelaApuracaoTaxaMediaMaximaAgente[];
  @Input() tranches: Tranche[];

  private _array = Array;
  constructor() { }

  ngOnInit(): void {
  }

  recuperarNumeroTranche(ideTranche: number) : number{
    return this.tranches.find(tranche => tranche.id == ideTranche).numeroTranche;
  }

}
